import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

function updateMastheadPadding(e) {
	const topHero = $(".site-main .layer--hero:first-child .hero");
	const topMH = $(".site-main .layer--masthead:first-child");
	if(topHero.length > 0) {
		els.masthead = topHero;
		if(els.viewport.width() <= breakpoints.sm) {
			els.masthead.find("> .inner").css({
				paddingBottom: $(".hero-buttons").outerHeight() + 20
			});
		} else {
			els.masthead.find("> .inner").css({
				paddingBottom: 0
			});
		}
	} else if (topMH.length > 0) {
		els.masthead = topMH;
	}
	els.masthead.css({
		paddingTop: els.header.outerHeight()
	});
}

window.addEventListener('load', updateMastheadPadding);
window.addEventListener('resize', helpers.debounce(updateMastheadPadding));
